// this contains named variables for the base tints and hues used in the other colour files.
// NOTE: These colours should never be used outside of fe-brary.
// Use colours from colour-scheme or color-atom-palette instead

export default (() => ({
  colour: {
    creSriracha400: '#ff7450',
    creSriracha500: '#ff5328',
    creSriracha600: '#e84a23',
    creSlate400: '#22365a',
    creSlate500: '#0b2047',
    creSlate600: '#071939',
    creYellow100: '#f3e3aa',
    creYellow500: '#ffd200',
    creYellow600: '#e3b100',
    creGreen100: '#bef7d6',
    creGreen400: '#1db660',
    creAqua100: '#b8f5f8',
    creAqua400: '#0091b8',
    creNavy100: '#cde8f4',
    creNavy400: '#2451a6',
    crePurple100: '#e3ddf4',
    crePurple400: '#4f2caf'
  }
}));